import FormField from "./FormField";
import { cn, colors } from "tools/ui";
import { theme } from "theme/theme";

const styleBase = "h-20 w-full py-2 px-2";
/**
 *
 * @param {*} props -
    const _valueRef = `${mode
 * @param {Boolean} readOnly -
 * @param {String} type -
 * @param {String} label -
 * @param {String} name -
 * @param {String} placeholder -
 * @param {String} value -
 * @param {Function} onChange -
 * @param {Boolean} translate -
 * @returns Component TextField
 */

function Text(props) {
  const {
    name,
    data,
    field,
    label,
    readOnly,
    placeholder,
    onChange,
    icon,
    colSpan,
    uppercase,
    rows,
    style,
    model,
  } = props;
  const _value = data.value || "";
  // if (_value && translate) {
  //   const _valueRef = `${layout.model}.${_value}`;
  //   _value = intl.msgs[_valueRef] || _value;
  // }

  const _style = styleBase;
  let _color = props.color ?? "bg-white";

  if (readOnly) {
    _color = colors.readOnly;
  }

  function handleChange(event) {
    let _value = event.target.value;
    if (uppercase) {
      _value = _value.toUpperCase();
    }
    data.value = _value;
    if (onChange) {
      onChange(name, _value);
    }
  }

  function onBlur(event) {
    const _value = event.target.value;
    if (onChange) {
      onChange(name, _value);
    }
  }

  return (
    <FormField
      label={label}
      name={name}
      required={field?.required}
      colspan={colSpan}
      model={model}
    >
      <textarea
        key={name}
        id={name}
        name={name}
        className={cn(_style, _color, theme.textColor, theme.border, style)}
        value={_value}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={readOnly ?? false}
        placeholder={placeholder ?? ""}
        rows={rows || 2}
      />
      {icon || null}
    </FormField>
  );
}

export default Text;
